// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.MuiDataGrid-columnHeader {
    background-color: #21252b !important;
}

.MuiDataGrid-scrollbarFiller--header {
    background-color: #21252b !important;
}

.cesium-dialog {
    z-index: 1000;
    position: absolute;
    height: 29px;
    right: 39px;
    bottom: 0px;
    color: white;
    font-size: small;
    text-shadow: 0 0 10px #000;
    line-height: 29px;
}

.nav a,
.nav a:hover {
    color: #fff;
    text-decoration: none;
    width: 100%;
}

.login a,
.login a:hover {
    color: #90caf9;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

button:focus {
    outline: none !important;
}

.cesium-baseLayerPicker-dropDown {
    z-index: 1;
}

.custom-baseLayerPicker-dropDown {
    padding: 16px;
    background-color: rgba(38, 38, 38, 0.75);
    position: absolute;
    right: 0;
    width: 90%;
    max-width: 300px;
    overflow: auto;
    border-radius: 10px;
    z-index: 1;

    /* fallback property in case a users browser doesn't support calc() */
    max-height: 75%;
    max-height: calc(100% - 82px);
    top: 50px;
}

.cmp-ui-chat-message > * {
    max-width: 100% !important;
}

.cmp-ui-chat-message .MuiPaper-root {
    padding: 0 8px 0 8px !important;
    margin-top: 0 !important;
}

.cmp-ui-conversation-menu-item {
    position: relative;
}

.cmp-ui-conversation-menu-item-options {
    visibility: hidden;
}

.cmp-ui-conversation-menu-item:hover .cmp-ui-conversation-menu-item-options {
    visibility: visible;
}

.cmp-ui-login-routes > * {
    color: #90caf9;
    font-size: smaller;
}

button.cesium-infoBox-camera {
    display: none;
    padding: 0px;
}

.error-boundary {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 2rem;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0.12);
}

.error-boundary > * {
    font-size: 1.5rem !important;
    margin-bottom: 0 !important;
}

.error-boundary > svg {
    font-size: 2.5rem !important;
}

.cesium-infoBox {
    width: 100%;
    max-width: 400px;
}

.control-button {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    border-color: transparent;
    background-color: white;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.control-button:hover {
    box-shadow: 0 0 3px #000;
}

.control-button > .MuiSvgIcon-root {
    color: #666;
    font-size: 1.3rem;
}

.control-button:hover > .MuiSvgIcon-root {
    color: #000;
}

.control-button-dark {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    border-color: transparent;
    background-color: #121212;
    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.control-button-dark:hover {
    box-shadow: 0 0 3px #000;
    cursor: pointer;
}

.control-button-dark > .MuiSvgIcon-root {
    color: white;
    font-size: 1.3rem;
}

.control-button-dark:hover > .MuiSvgIcon-root {
    color: azure;
}
`, "",{"version":3,"sources":["webpack://./client/src/css/cmp.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,UAAU;;IAEV,qEAAqE;IACrE,eAAe;IACf,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,uFAAuF;IACvF,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["html,\r\nbody {\r\n    padding: 0;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.MuiDataGrid-columnHeader {\r\n    background-color: #21252b !important;\r\n}\r\n\r\n.MuiDataGrid-scrollbarFiller--header {\r\n    background-color: #21252b !important;\r\n}\r\n\r\n.cesium-dialog {\r\n    z-index: 1000;\r\n    position: absolute;\r\n    height: 29px;\r\n    right: 39px;\r\n    bottom: 0px;\r\n    color: white;\r\n    font-size: small;\r\n    text-shadow: 0 0 10px #000;\r\n    line-height: 29px;\r\n}\r\n\r\n.nav a,\r\n.nav a:hover {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    width: 100%;\r\n}\r\n\r\n.login a,\r\n.login a:hover {\r\n    color: #90caf9;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-inner-spin-button,\r\ninput[type=\"number\"]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    margin: 0;\r\n}\r\n\r\nbutton:focus {\r\n    outline: none !important;\r\n}\r\n\r\n.cesium-baseLayerPicker-dropDown {\r\n    z-index: 1;\r\n}\r\n\r\n.custom-baseLayerPicker-dropDown {\r\n    padding: 16px;\r\n    background-color: rgba(38, 38, 38, 0.75);\r\n    position: absolute;\r\n    right: 0;\r\n    width: 90%;\r\n    max-width: 300px;\r\n    overflow: auto;\r\n    border-radius: 10px;\r\n    z-index: 1;\r\n\r\n    /* fallback property in case a users browser doesn't support calc() */\r\n    max-height: 75%;\r\n    max-height: calc(100% - 82px);\r\n    top: 50px;\r\n}\r\n\r\n.cmp-ui-chat-message > * {\r\n    max-width: 100% !important;\r\n}\r\n\r\n.cmp-ui-chat-message .MuiPaper-root {\r\n    padding: 0 8px 0 8px !important;\r\n    margin-top: 0 !important;\r\n}\r\n\r\n.cmp-ui-conversation-menu-item {\r\n    position: relative;\r\n}\r\n\r\n.cmp-ui-conversation-menu-item-options {\r\n    visibility: hidden;\r\n}\r\n\r\n.cmp-ui-conversation-menu-item:hover .cmp-ui-conversation-menu-item-options {\r\n    visibility: visible;\r\n}\r\n\r\n.cmp-ui-login-routes > * {\r\n    color: #90caf9;\r\n    font-size: smaller;\r\n}\r\n\r\nbutton.cesium-infoBox-camera {\r\n    display: none;\r\n    padding: 0px;\r\n}\r\n\r\n.error-boundary {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    gap: 2rem;\r\n    border: 1px solid;\r\n    border-color: rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.error-boundary > * {\r\n    font-size: 1.5rem !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.error-boundary > svg {\r\n    font-size: 2.5rem !important;\r\n}\r\n\r\n.cesium-infoBox {\r\n    width: 100%;\r\n    max-width: 400px;\r\n}\r\n\r\n.control-button {\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 3px;\r\n    border-color: transparent;\r\n    background-color: white;\r\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.control-button:hover {\r\n    box-shadow: 0 0 3px #000;\r\n}\r\n\r\n.control-button > .MuiSvgIcon-root {\r\n    color: #666;\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.control-button:hover > .MuiSvgIcon-root {\r\n    color: #000;\r\n}\r\n\r\n.control-button-dark {\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 3px;\r\n    border-color: transparent;\r\n    background-color: #121212;\r\n    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));\r\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.control-button-dark:hover {\r\n    box-shadow: 0 0 3px #000;\r\n    cursor: pointer;\r\n}\r\n\r\n.control-button-dark > .MuiSvgIcon-root {\r\n    color: white;\r\n    font-size: 1.3rem;\r\n}\r\n\r\n.control-button-dark:hover > .MuiSvgIcon-root {\r\n    color: azure;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
